import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import { BottomFiller, GradiantOverlay, GraphWrapper } from './BackgroundGraph.styled';
import { CategoryScale, Chart as ChartJS, Filler, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useStore } from '@store/appStore';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

interface IProps {
  height?: number;
  paddingBottom?: number;
  dataPoints: any;
}

export const BackgroundGraph = (props: IProps) => {
  const {settings} = useStore();


  let newDataPoints = props.dataPoints?.map(dp => ShowabsenceOrAttendance(settings.SHOWPRESENCE, dp)) 

  let minValue = (Math?.min(...(newDataPoints ?? [])) - 10) 

  if(minValue <= 0) minValue = 0

  const data = {
    labels: newDataPoints,
    datasets: [
      {
        data: newDataPoints,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      line: {
        borderColor: 'rgba(47, 97, 68, 0)',
        backgroundColor: 'rgba(185, 212, 215, 1)',
        fill: 'start',
        tension: 0.2,
      },
      point: {
        radius: 0,
        hitRadius: 0,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        min: minValue,
      },
    },
    layout: {
      padding: 0,
    },
  };

  return (  
    <GraphWrapper paddingBottom={props.paddingBottom ? props.paddingBottom : 0}>
      <Line data={data} width={100} height={props.height ? props.height : 30} options={options} />
      <BottomFiller />
      <GradiantOverlay />
    </GraphWrapper>
  );
};

export default BackgroundGraph;
